import React,{ useState, useEffect, useRef} from 'react';
import { Link } from 'react-router-dom';
import { Waypoint } from 'react-waypoint';
import Common from '../common_component/Common';
import * as animationjs from '../../animation';

import imgPath_mov from '../../images/scale_img.mov';
import holiday_bg from '../../images/holiday_bg.gif';
import map from '../../images/map.png';
import mobile_scrn from '../../images/mobile_scrn.png';
import left_icon from '../../images/left_icon.png';
import right_icon from '../../images/right_icon.png';
import caretIcon from '../../images/caretIcon.png';

import news1 from '../../images/news_1.png';
import news2 from '../../images/news_2.png';
import news3 from '../../images/news_3.png';
import news4 from '../../images/news_4.png';
import news5 from '../../images/news_5.png';

import './Home.css';

function Home() {
  const [homeUrl,setHomeUrl] = useState(true);
  const [scrolled,setScrolled] = useState(false);
  const [getScrnWidth,setGetScrnWidth] = useState(false);
  const [teamData,setTeamData] = useState({testiData:null});
  const api_url = 'https://www.travsie.com/admin/';

  useEffect(()=>{
    getPagetitle();
    getTestimonial();

    window.addEventListener('scroll',handleScroll);
    if(window.innerWidth>767){
      moveActive1('benefitsBox');
      setGetScrnWidth(true);
    }else{
      setGetScrnWidth(false);
    }
    if(document.querySelector('#benefitsInner')!=null){
   
      document.querySelector('#benefitsInner').addEventListener("mouseenter", insideElm); 
      document.querySelector('#benefitsInner').addEventListener("mouseleave", outsideElm);
    } 
  },[]);

  const getPagetitle = ()=>{
    document.title = 'Travsie';
  }
 const handleScroll = ()=>{
    window.scrollY >0?setScrolled(true):setScrolled(false);
  }

let rmvTimer1;
let countNo = 0;
function moveActive1(cls){ 
  let liElm = document.querySelectorAll('.'+cls+' li');  
  if(countNo<liElm.length){
        if(document.querySelector('.'+cls+' li.active') != null){
          document.querySelector('.'+cls+' li.active').classList.remove('active');
        }
        liElm[countNo].classList.add('active');  
        countNo++;
      }


 if(countNo<liElm.length){  
  rmvTimer1= setTimeout(function(){
          moveActive1("benefitsBox");
      },2000);
 }
else{	   
    countNo= 0;  
    rmvTimer1=setTimeout(function(){
      moveActive1("benefitsBox");
  },2000);
    
}
}
const outsideElm = (e) => { 
  moveActive1("benefitsBox");
}
const insideElm = (e) => {
  clearTimeout(rmvTimer1);   
}

  const addAniClass = (cls,n)=>{
    if(window.innerWidth>767){
      animationjs.addAniClass(cls,n);
    }else{
      if (document.querySelector('.'+cls) != null) {
        if(cls=='ourSolution'){
          if(n=='0'){
            setTimeout(()=>{animationjs.moveActiveMobile('customizeBox')},3200);
          }
        }
      }
    }
  }

  const mOver = (idd,cls)=>{
    document.querySelector('.'+cls+'.active').classList.remove('active');
    document.querySelector('#'+idd).classList.add('active');
  }

  const removeAniClass = (cls)=>{
    if(window.innerWidth>767){
      animationjs.removeAniClass(cls);
    }
  }

  const getTestimonial  = async()=>{
    try{
      let formData = new FormData();  
      formData.append('action','getTestimonials');
      return await fetch(api_url+`ajax_login.php`,{
        method:'POST',
        headers: {
          'Accept':'application/json',
        },
        body: formData
      }).then((response)=> response.json()).then((resData)=> {
        if(resData.success){
          setTeamData({...teamData,testiData:resData.success});
        }
      })
    }catch(e){
      console.log(e);
    }
    
  }

  const getRating = (rating)=>{
    var star_rating = [];
      for (var i = 1; i<=rating; i++){
        star_rating.push(<i style={{fontSize:'20px',color:'#ff8f00',margin:'0 3px'}} className="fa fa-star" aria-hidden="true"></i>);
      }
    return star_rating;
  }

  return (
    <section className="row_hb holidaySCntr pad_t_50">
      <div className={`${scrolled==true?'active':''} btn_box`}>      
        <a href="https://www.travsie.com/admin/login.php" className="btn_login">
            Agent Login
        </a>
        <a href="https://www.travsie.com/signup/agent" className="btn_reg" >
          Agent Registration 
        </a>
      </div>
      <div className="row_hb">
        <div className="container">
          <div className="row_hb">
            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5 pad_l_0 mob_p_r_0">
                <div className="row_hb teamMobile">
                  <h1 className="txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 mob_text_align_c fnt_size_45 line_height_60">A Global Distribution System for <span className="txt_color_3 display_block">Holiday Packages</span></h1>
                  
                  {getScrnWidth==false?<div className="row_hb">
                    <video className="row_hb" x-webkit-airplay="allow" defaultmuted="defaultmuted" muted="muted" playsInline="" autoPlay="autoplay" loop="loop">
                      <source src={imgPath_mov} type="video/mp4" />
                    </video>
                  </div>:null}
                  
                  <p className="mob_row_hb fnt_size_22 mar_a_0 pad_t_20 pad_b_20 font_fam_halvetica mob_p_r_0">Travsie, a category-defining travel-tech infrastructure, is building a global holiday distribution network that unifies fragmented DMC sales workflows and connects them instantly with travel agents, OTAs, and B2B channels worldwide.</p>
                  <p className="mob_row_hb pad_a_0"><strong className="txt_color_3 pad_a_0 mob_font_size_15 fnt_weight_700 fnt_size_30">Discover, scale and get started:  </strong></p>

                  <div className="row_hb pad_t_15 mob_p_t_15">
                    <Link to="/signup/agent" id="agent_id" onMouseOver={()=>mOver('agent_id','btnAgent')} className="btn btn-sm btnAgent active text_align_c fnt_weight_500 mar_r_20 mob_mar_r_10 border_rad_8 mob_font_size_14  fnt_size_17 min_width_200 mob_min_width txt_color_3">I am an agent	<i className="fa fa-angle-right pad_l_10" aria-hidden="true"></i></Link>
                    <Link to="/signup/supp" id="supp_id" onMouseOver={()=>mOver('supp_id','btnAgent')} className="btn btn-sm btnAgent text_align_c fnt_weight_500 border_rad_8 mob_font_size_14 fnt_size_17 min_width_200 mob_min_width txt_color_3">I am a supplier <i className="fa fa-angle-right pad_l_10" aria-hidden="true"></i></Link>
                  </div>
                </div>
            </div>

            {getScrnWidth==true?<div className="col-xs-12 col-sm-7 col-md-7 col-lg-7 pad_r_0">
                <video style={{width:'92%',float:'right'}} x-webkit-airplay="allow" defaultmuted="defaultmuted" muted="muted" playsInline="" autoPlay="autoplay" loop="loop">
                  <source src={imgPath_mov} type="video/mp4" />
                </video>
            </div>:null}

          </div>
        </div>
      </div>

      <Common homeData={homeUrl}/>

      <div className="row_hb pad_t_70 m_p_t_50 bg_col">
        <Waypoint onEnter={()=>addAniClass('ourSolution','0')} onLeave={()=>removeAniClass('ourSolution')}>
        <div className="container">
          <div className="row_hb ourSolution">
            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5 pad_l_0 mob_p_r_0">
                <div className="row_hb pad_t_180 mob_p_t_0 mob_p_b_15 slideInLeftElm slow mob_text_align_c animated teamMobile">
                  <h2 className="txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 fnt_size_45">Our <span className="txt_color_3 mob_d_block">Solution</span></h2>
                  <p className="fnt_size_22 mar_a_0 pad_t_20 pad_b_20 mob_p_t_15 font_fam_halvetica pad_r_10">We've fixed the core supply-chain gaps - from sourcing to servicing - turning every stakeholder into our customer, be it small travel agents, OTAs, or DMCs.</p>
                </div>
            </div>

            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7 pos_relative pad_r_0 mob_p_l_0">
                <div className="row_hb">
                  <img className="whSet mob_d_none mob_pos_unset mob_mid_aligne1 slideInRightElm animated slow delay-1s" src={mobile_scrn} alt=""/>
                  <ul className="customizeBox mob_p_t_15 zoomInUpElm animated slower delay-1s mar_l_70 pos_relative index_2 mar_b_0">
                    <li className="active">
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText left">30-sec <br/>Customization </span>
                    </li>

                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText right">Scale</span>
                    </li>

                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText left">Speed</span>
                    </li>

                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText right">Enterprise SaaS</span>
                    </li>

                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText left">Real-time</span>
                    </li>

                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText right">Holiday APIs</span>
                    </li>

                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText left">Ops Automation</span>
                    </li>

                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText right">Unified Marketplace</span>
                    </li>
                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText left">Transparency</span>
                    </li>

                    <li>
                      <span className="pole"></span>
                      <span className="topDot"></span>
                      <span className="descText right">Seamless <br/> Distribution</span>
                    </li>
                  </ul>
                </div>
            </div>

          </div>
        </div>
        </Waypoint>
      </div>
       
      <div className="row_hb pad_t_30 pad_b_70">
        <div className="container">
          <div className="row_hb">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 pad_l_0 mob_p_r_0">
                <div className="row_hb disp_flex pad_t_25 mob_p_t_0">

                  <div className="col-xs-12 col-sm-10 col-md-10 col-lg-10">
                    <div className="row_hb pos_relative">
                        <div className="aboutAnimate moveimgBgSm howWeElm index_1 pos_absolute"></div>
                        <div className="row_hb text_align_c minht_130">
                            <img className="mob_m_t_b_25 mar_t_30" src={right_icon} alt=""/>
                        </div>
                        <div className="row_hb mar_t_30 pad_a_25 bg_what_how min_ht_480 mob_min_ht border_rad_8 ">
                          <div className="row_hb teamMobile">
                            <h2 className="txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 fnt_size_45 text_align_c">What we <span className="txt_color_3">do</span></h2>
                          </div>

                          <ul className="row_hb mar_a_0 doULElm mob_p_l_0 mob_p_r_0 pos_relative index_2">
                            <li className="row_hb pad_b_20 mob_p_b_15">
                                <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">We enable and empower the supplier-agent relationship</span>
                            </li>
                            <li className="row_hb pad_b_20 mob_p_b_15">
                              <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">We optimize business processes between travel agents and global suppliers – from sourcing to servicing</span>
                            </li>
                            <li className="row_hb pad_b_20 mob_p_b_15">
                                <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">A B2B marketplace to streamline transactions between travel agents and suppliers</span>
                            </li>
                            <li className="row_hb">
                                <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">We build relationships with global travel partners, while our platform takes care of their business needs. </span>
                            </li>
                          </ul>
                        </div>
                    </div>
                  </div>

                </div>
            </div>
          
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 pad_l_0 mob_p_r_0">
                <div className="row_hb disp_flex pad_t_25 mob_p_t_0">

                  <div className="col-xs-12 col-sm-10 col-md-10 col-lg-10">
                    <div className="row_hb pos_relative">
                        <div className="aboutAnimate moveimgBgSm last index_1 pos_absolute"></div>
                        <div className="row_hb text_align_c minht_130">
                            <img className="mob_m_t_b_25 mob_m_t_b_25_1024"  src={left_icon} alt=""/>
                        </div>
                        <div className="row_hb mar_t_30 pad_a_25 bg_what_how min_ht_480 mob_min_ht border_rad_8 ">
                          <div className="row_hb teamMobile">
                            <h2 className="txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 fnt_size_45 text_align_c">How we <span className="txt_color_3">do it</span></h2>
                          </div>
                          <ul className="row_hb mar_a_0 doULElm mob_p_l_0 mob_p_r_0 pos_relative index_2">
                            <li className="row_hb pad_b_20 mob_p_b_15">
                                <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">Streamlining sales & operational funnels for DMCs</span>
                            </li>
                            <li className="row_hb pad_b_20 mob_p_b_15">
                              <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">Pioneering APIs for holiday packages & land services</span>
                            </li>
                            <li className="row_hb pad_b_20 mob_p_b_15">
                                <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">Single-Step customization in under 30 seconds</span>
                            </li>
                            <li className="row_hb pad_b_20 mob_p_b_15">
                                <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">Hybrid marketplace with value-added services</span>
                            </li>

                            <li className="row_hb  pad_b_20 mob_p_b_15">
                                <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">Unified access to agents, OTAs, airlines, and loyalty platforms</span>
                            </li>
                            <li className="row_hb">
                                <img src={caretIcon} alt=""/>
                                <span className="font_fam_halvetica fnt_size_15">Eliminating intermediaries</span>
                            </li>


                          </ul>
                        
                        </div>
                    </div>
                  </div>

                </div>
            </div>
          
          </div>
        </div>
      </div>

      <div className="row_hb pad_t_70 pad_b_70 bg_col m_p_t_b_50">
        <Waypoint onEnter={()=>addAniClass('theBenefits','0')} onLeave={()=>removeAniClass('theBenefits')}>
          <div className="container">
          <div className="row_hb theBenefits">
            <div className="row_hb text_align_c teamMobile mob_text_align_c">
              <h2 className="txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 fnt_size_45 line_height_60">The benefits  <span className="txt_color_3 ">we deliver</span></h2>
            </div>
              <div className="row_hb mob_d_none">
                <ul id="benefitsInner" className="row_hb benefitsBox slideInRightElm slower animated pos_relative">
                  <li className="active">
                    <span className="pole"></span>
                    <span className="startDot"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Digitizing small <br/>and medium-size <br/>businesses </span>
                  </li>

                  <li>
                    <span className="pole"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon_3"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Real time <br/>quotes from <br/>global suppliers  </span>
                  </li>

                  <li>
                    <span className="pole"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon_2"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Direct access & transactions with <br/>global suppliers</span>
                  </li>

                  <li>
                    <span className="pole"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon_1"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Ease of <br/>doing business<br/> No emails </span>
                  </li>

                  <li>
                    <span className="pole"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon_4"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Wide choice of products and value-added services</span>
                  </li>

                  <li>
                    <span className="pole"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon_5"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Efficient, digital booking & communication process</span>
                  </li>

                  <li>
                    <span className="pole"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon_6"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Higher volumes <br/>for agents and<br/> suppliers</span>
                  </li>

                  <li>
                    <span className="pole"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon_8"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Integrated <br/>invoicing and<br/> voucher tool</span>
                  </li>

                  <li>
                    <span className="pole"></span>
                    <span className="endDot"></span>
                    <span className="topDot"></span>
                    <span className="topicon icon_7"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Long-term <br/>profitability and<br/> business stability </span>
                  </li>
                </ul>
              </div>

              <div className="row_hb mob_d_block display_none">
                <ul className="row_hb benefitsBoxNew ">
                  <li>
                    <span className="topicon icon"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Digitizing small and medium-size businesses </span>
                  </li>

                  <li>
                    <span className="topicon icon_3"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Real time quotes from global suppliers </span>
                  </li>

                  <li>
                    <span className="topicon icon_2"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Direct access & transactions with global suppliers</span>
                  </li>

                  <li>
                    <span className="topicon icon_1"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Ease of doing business No emails</span>
                  </li>

                  <li>
                    <span className="topicon icon_4"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Wide choice of products and value-added services</span>
                  </li>

                  <li>
                    <span className="topicon icon_5"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Efficient, digital booking & communication process</span>
                  </li>

                  <li>
                    <span className="topicon icon_6"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Higher volumes for agents and suppliers</span>
                  </li>

                  <li>
                    <span className="topicon icon_8"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Integrated invoicing and voucher tool</span>
                  </li>

                  <li>
                    <span className="topicon icon_7"></span>
                    <span className="descText bottom text_align_c font_fam_halvetica">Long-term profitability and business stability</span>
                  </li>
                </ul>
              </div>
          </div>
        </div>
        </Waypoint>
      </div>
     
      <div className="row_hb">
        <Waypoint onEnter={()=>addAniClass('foresee','1')} onLeave={()=>removeAniClass('foresee')}>
          <div className="row_hb foresee pos_relative overf_hid">
            <img className="rightFixImg slideInRightElm slow delay-2s animated" src={map} alt=""/>
            <div className="container">
              <div className="row_hb pad_t_70 pad_b_70 m_p_t_b_50">
                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5 pad_l_0 mob_p_r_0">
                    <div className="row_hb pad_t_25 slideInLeftElm slow animated teamMobile">
                      <h2 className="txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 mob_text_align_c fnt_size_45 line_height_60">How we foresee  <span className="txt_color_3 display_block">ourselves</span></h2>
                      <p className="fnt_size_22 mar_a_0 pad_t_20 mob_p_t_15 pad_b_20 font_fam_halvetica pad_r_10">We are building toward a “One World - One Platform” vision for seamless global distribution by creating the backbone that moves every holiday package through our platform - delivering unmatched speed, efficiency, and transparency.</p>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7 pad_r_0 mob_p_l_0">
                    <div className="row_hb text_align_r">
                        <img className="holiImg aniIElm mobsize" src={holiday_bg} alt=""/>
                    </div>
                </div>
              </div>
            </div>
            </div>
        </Waypoint>
      </div>

      {/* {teamData.testiData!=null?
        <div className="row_hb pad_t_70 pad_b_70 teamMobile mob_p_b_0 mob_p_t_35 bg_col">
          <div className="row_hb theBenefits">
            <div className="container">
              <div className="row_hb">
                <div className="row_hb">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 pad_l_0 pad_r_0">
                    <div className="row_hb text_align_c">
                      <h2 className="txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 fnt_size_45">User  <span className="txt_color_3">Experience</span></h2>
                      <p className="row_hb pad_t_20 pad_b_20 fnt_size_20" style={{display:'none'}}></p>
                    </div>
                  </div>
                </div>
              
                <div className="row_hb pad_t_50 mob_p_t_25 mobViewelm" style={{display:'flex',justifyContent:'center',alignContent:'center'}}>
                    {teamData.testiData.map((item,indx)=>
                    <div key={`team_${indx}`} className="col-xs-12 col-sm-3 col-md-3 col-lg-3 ">
                      <div className="row_hb teamBox border_rad_8 text_align_c pad_a_20 pos_relative" style={{minHeight:'150px'}}>

                          {item.imagepath!=''?
                            <span className={`aboutComp`} style={{height:'90px'}}>
                              <img style={{width:'60px',borderRadius:'5px'}} src={api_url+'uploads/testimonials/'+item.imagepath}  alt="Travsie"/>
                            </span>
                          :
                            <span className={`aboutComp`} style={{height:'90px',overflow:'hidden'}}>
                              <img style={{width:'75px',borderRadius:'5px'}} src={api_url+'uploads/testimonials/avatar5.png'}  alt="Travsie"/>
                            </span>
                          }

                          <h4 className="row_hb txt_color_5 fnt_size_15 line_height_24">{item.name} <span className="font_fam_halvetica fnt_size_15 display_block fnt_weight_300 txt_color_8">{item.city}</span></h4>
                          <p className="row_hb fnt_size_13 line_height_22">{getRating(item.star_rating)}</p>
                          <p className="row_hb fnt_size_13 line_height_22">{item.testimonial}</p>
                      </div>
                    </div>
                    )}
                </div>
              
              </div>
            </div>
          </div>
        </div>
      :null} */}

      <div className="row_hb newsCntr" style={{paddingTop:'50px'}}>
        <div className="container pad_b_45 bor_b mar_b_15">
            <h2 className="row_hb mar_b_25 txt_color_5 fnt_weight_800 mar_a_0 text-center pad_a_0 fnt_size_35">Travsie <span className="txt_color_3 mob_d_block">in the News</span></h2>
            <ul className="row_hb newsBox text_align_c">
                <li><a href="https://travel.economictimes.indiatimes.com/news/technology/travsie-launches-industrys-first-b2b-holiday-sourcing-platform-with-over-1100-agents-and-suppliers-on-board-receives-seed-funding/88311354" target="_blank"><img src={news1} alt=""/></a></li>
                <li><a href="https://theprint.in/ani-press-releases/travsie-launches-industrys-first-b2b-holiday-sourcing-platform-with-1100-agents-and-suppliers-on-board-receives-seed-funding/782120/" target="_blank"><img src={news3} alt=""/></a></li>
                <li><a href="https://www.business-standard.com/content/press-releases-ani/travsie-launches-industry-s-first-b2b-holiday-sourcing-platform-with-1100-agents-and-suppliers-on-board-receives-seed-funding-121121501030_1.html" target="_blank"><img src={news4} alt=""/></a></li>
                <li><a href="https://www.mid-day.com/brand-media/article/travsie-launches-industry-first-b2b-holiday-sourcing-platform-23205888" target="_blank"><img src={news5} alt=""/></a></li>
            </ul>
        </div>
      </div>
    </section>
  );
}

export default Home;